import './ProductCard.scss'
import 'animate.css'
import Link from 'next/link'
import { ProductCardSpecial } from './ProductCardSpecial'
import { ProductCardImage } from './ProductCardImage'

export function ProductCard(
    {
        image,
        name,
        sku,
        price,
        specials = false,
        url,
        children,
        showActions = true,
        nameNode,
    },
    ...props
) {
    return (
        <div className={'ProductCard animate__animated animate__fadeIn'}>
            <Link
                href={'/' + url}
                // target="_blank"
                role="button"
                className={'img'}  style={{ position: 'relative' }}
            >
                <ProductCardImage image={image} />
                <div className='article-number'>
                    {sku}
                </div>
            </Link>
            <div className={'bottom-container'}>
                <Link
                    href={'/' + url}
                    // target="_blank"
                >
                    {nameNode ? (
                        nameNode
                    ) : (
                        <h3 role="button" className={'title'}>
                            {name}
                        </h3>
                    )}
                </Link>
                <div className={'footer'}>
                    <ProductCardSpecial price={price} specials={specials} sku={sku} name={name} />
                    {showActions && <div className={'actions'}>{children}</div>}
                </div>
            </div>
        </div>
    )
}

